import { jsxs as h, jsx as g } from "react/jsx-runtime";
import { CheckmarkIcon as C } from "./icons/index.es.js";
import { useState as E, useEffect as I, useMemo as b, Children as L, isValidElement as O, forwardRef as z } from "react";
import { Box as A, Text as B } from "@chakra-ui/react";
import "./atoms/Button/Button.es.js";
import "./molecules/Dropdown/Dropdown.context.es.js";
import { DropdownItem as D } from "./molecules/Dropdown/components/DropdownItem.es.js";
import "./molecules/Dropdown/Dropdown.container.es.js";
import { SELECT_SORT as x, SELECT_SORT_ICON as P } from "./molecules/Select/Select.constants.es.js";
import { c as T } from "./index-226b8ea6.js";
import "./atoms/Tooltip/Tooltip.es.js";
const [X, R] = T({
  name: "SelectStylesContext",
  errorMessage: `useSelectStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Select />" `
}), Y = ({
  children: c,
  defaultValue: i,
  onChange: s,
  value: a,
  placeholder: d
}) => {
  const [r, n] = E(a ?? i), [l, f] = E(void 0);
  I(() => {
    a !== r && n(a ?? i);
  }, [a]);
  const m = b(() => L.map(c, (t) => {
    if (O(t) && t.type === j) {
      const { icon: e, isSorting: o, children: S, value: p } = t.props;
      return p === r && o && f(x.asc), {
        icon: e,
        isSorting: o,
        label: S,
        value: p ?? S
      };
    }
  }), [c]), u = b(
    () => m.find((t) => r && t.value === r),
    [m, r]
  );
  return {
    defaultValue: i,
    direction: l,
    handleChange: (t) => {
      const e = m.find((S) => S.value === t), o = l === x.asc ? x.desc : x.asc;
      e && e.isSorting && f(o), n(t), e != null && e.isSorting || f(void 0), e && s && s({
        ...e,
        direction: e.isSorting ? o : void 0
      }), t === "" && (n(i), s == null || s({ label: d ?? "", value: "" }));
    },
    options: m,
    selected: u,
    value: r
  };
}, [Z, V] = T(), j = z(
  ({ children: c, description: i, icon: s, isDisabled: a, isSorting: d, trackId: r, value: n, onClick: l, ...f }, m) => {
    const { direction: u, value: v, handleChange: t } = V(), e = u && P[u], o = n === "", p = !!(!o && v && v === (n ?? c)), y = R(), _ = o ? { ...y.option, ...y.placeholder } : y.option;
    return /* @__PURE__ */ h(
      D,
      {
        __css: _,
        active: p,
        isDisabled: a,
        onClick: (w) => {
          t(n ?? c), l == null || l(w);
        },
        ref: m,
        "track-id": r,
        ...f,
        children: [
          s,
          /* @__PURE__ */ h(A, { display: "flex", flex: 1, flexWrap: "wrap", children: [
            c,
            i && /* @__PURE__ */ g(
              B,
              {
                as: "span",
                flexBasis: "100%",
                color: "primary.700",
                fontSize: "sm",
                lineHeight: 1.2,
                textAlign: "left",
                children: i
              }
            )
          ] }),
          p && !o && !d && /* @__PURE__ */ g(C, { boxSize: 4, marginLeft: "auto" }),
          p && !o && e && d && /* @__PURE__ */ g(e, { boxSize: 4, marginLeft: "auto" })
        ]
      }
    );
  }
);
export {
  j as S,
  Z as a,
  X as b,
  R as c,
  V as d,
  Y as u
};
//# sourceMappingURL=SelectOption-a05022b4.js.map
